import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import TableBody from "@material-ui/core/TableBody";
import { toast } from "react-toastify";

export default function CreateGame(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "600px",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + "T" + time;
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const [dateChanged, setDateChanged] = React.useState();
  const [counterChanged, setCounterChanged] = React.useState(0);
  const [type, setType] = React.useState([]);
  const [expirationDateChanged, setExpirationDateChanged] =
    React.useState(false);
  const [typeMessage, setTypeMessage] = React.useState(1);
  const [displayCounterChanged, setDisplayCounterChanged] =
    React.useState(false);
  const [disabledMessageChanged, setDisabledMessageChanged] =
    React.useState(false);
  const [message, setMessage] = React.useState();

  const [loading, setLoading] = React.useState(false);
  const [acceptAutoChanges, setAcceptAutoChanges] = React.useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const [players, setPlayers] = useState([]);
  const [renderShowsTotal, setRenderShowsTotal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  function onAfterDeleteRow(rowKeys) {
    alert("The rowkey you drop: " + rowKeys);
  }

  const handleRowSelect = (row, isSelected) => {
    setSelectedIds((prev) =>
      isSelected
        ? [...prev, row.IdPlayer]
        : prev.filter((id) => id !== row.IdPlayer)
    );
  };

  const handleSelectAll = (isSelected, rows) => {
    if (isSelected) {
      setSelectedIds(rows.map((row) => row.IdPlayer));
    } else {
      setSelectedIds([]);
    }
  };

  useEffect(() => {
    console.log(selectedIds)
  }, [selectedIds])

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    clickToExpand: true,
    onSelect: handleRowSelect,
    onSelectAll: handleSelectAll,
    selected: selectedIds
  };



  const options = {
    page: 1,
    sizePerPageList: [
      { text: "15", value: 15 },
      { text: "50", value: 50 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    sizePerPage: 10,
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    paginationShowsTotal: renderShowsTotal,
    paginationPosition: "bottom",
  };

  const moveFormatter = (cell) => {
    if (cell === true) {
      return <i className="text-green-500 fa fa-check"></i>;
    } else if (cell === false) {
      return <i className="text-red-500 fa fa-times"></i>;
    }
    return null;
  };


  useEffect(() => {
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/Agent_GetPlayersList",
      data: {
        prmIdAgent: props.IdAgent,
        prmDecimals: 0,
        prmTrunc: 1,
        prmIdCurrency: props.IdCurrency,
      },
    }).then((response) => {
      setPlayers([response.data]);

      const allIds = response.data.map((player) => player.IdPlayer);
      setSelectedIds(allIds); // Marca todas las filas por defecto
    });
  }, [props.IdAgent]);


  const handleChangeDateTime = (event) => {
    setDateChanged(event.target.value);
  };
  const handleChangeCounter = (event) => {
    setCounterChanged(event.target.value);
  };
  const handleChangeDisplayCounter = (event) => {
    setDisplayCounterChanged(!displayCounterChanged);
  };
  const handleChangeDisabledMessage = (event) => {
    setDisabledMessageChanged(!disabledMessageChanged);
  };
  const handleTypeChanged = (event) => {
    setTypeMessage(event.target.value);
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleExpirationDateChanged = () => {
    setExpirationDateChanged(!expirationDateChanged);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };

  const handleOk = () => {
    if (selectedIds.length === 0) {
      toast.error("A player must be selected")
      return
    }

    if (!message) {
      toast.error("Message is empty")
    }
    const requests = selectedIds.map((id) => ({
      IdPlayer: id,
      Message: message.value ? message.value : message,
      MessageType: typeMessage.toString() == "0" ? false : true,
      UseExpirationDate: expirationDateChanged.value
        ? expirationDateChanged.value
        : expirationDateChanged,
      UseDisplayCounter: displayCounterChanged.value
        ? displayCounterChanged.value
        : displayCounterChanged,
      UseCloseOption: disabledMessageChanged.value
        ? disabledMessageChanged.value
        : disabledMessageChanged,
      ExpirationDate: dateChanged
        ? dateChanged.replace(" ", "T").split(".")[0]
        : new Date(),
      IdUser: userInfo.userId,
      DisplayCounter: counterChanged,
    }));
    console.log(requests)
    console.log(typeMessage)
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/PlayerMessages_Insert",
      data: requests,
    }).then((response) => {
      if (response.data === 0) {
        toast.success(`Message created successfully`);
      } else {
        toast.success(`An error occurred while creating the message.`);
      }
      handleClose();
    });
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              New Player Message
            </Typography>
          </Toolbar>
        </AppBar>

        <Table className={classes.table} aria-label="simple table">
          <TableBody>
            {players && (
              <div>
                <BootstrapTable
                  // pagination
                  options={options}
                  selectRow={selectRowProp}
                  version="4"
                  data={players[0]}
                  hover
                  className="max-w-[700px] m-auto pt-4"
                >
                  <TableHeaderColumn dataField="IdPlayer" isKey hidden>
                    Field A
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Player" >
                    Player
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Name">Name</TableHeaderColumn>

                </BootstrapTable>
              </div>
            )}
          </TableBody>
        </Table>

        {loading ? (
          <CircularProgress style={{ margin: "0 auto" }} />
        ) : (
          <React.Fragment>
            <br />
            <form className={`m-auto text-center flex gap-3 w-[700px] justify-between`}>
              <FormGroup row>
                <TextField
                  style={{ width: "400px" }}
                  type="text"
                  label="Message"
                  value={message}
                  multiline={true}
                  rows="4"
                  onChange={handleChangeMessage}
                  variant="outlined"
                  InputProps={{
                    style: {
                      height: "100%",
                      boxSizing: "border-box",
                    },
                  }}
                />
              </FormGroup>
              {/* <Divider /> */}
              <div className="flex flex-col items-start w-full">
                <FormGroup row>
                  <RadioGroup row>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={typeMessage == "0"}
                          onChange={handleTypeChanged}
                          value="0"
                          label="Normal"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Home" }}
                        // disabled
                        />
                      }
                      label="Normal"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          checked={typeMessage == "1"}
                          onChange={handleTypeChanged}
                          value="1"
                          label="Permanent"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Visitor" }}
                        // disabled
                        />
                      }
                      label="Permanent"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormGroup>
                {/* <Divider /> */}
                {typeMessage == 0 ? (
                  <FormGroup row className="h-[40px] items-center ">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={expirationDateChanged}
                          onChange={handleExpirationDateChanged}
                          color="primary"
                        />
                      }
                      label="Expiration Date"
                    />
                    {expirationDateChanged ? (

                      <input type="datetime-local" id="gameDateTime" onChange={handleChangeDateTime} className="h-[35px] border border-gray-200 rounded-md p-2" />
                    ) : (
                      ""
                    )}
                  </FormGroup>
                ) : (
                  ""
                )}
                {/* <Divider /> */}
                {typeMessage == 0 ? (
                  <FormGroup row className="h-[40px] items-center ">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={displayCounterChanged}
                          onChange={handleChangeDisplayCounter}
                          color="primary"
                        />
                      }
                      label="Display Counter"
                    />
                    {displayCounterChanged ? (
                      <input type="number" id="outlined-number" placeholder="Counter" onChange={handleChangeCounter} className="h-[35px] border border-gray-200 rounded-md p-2" />
                    ) : (
                      ""
                    )}
                  </FormGroup>
                ) : (
                  ""
                )}
                {/* <Divider /> */}
                {typeMessage == 0 ? (
                  <FormGroup row className="h-[40px] items-center ">
                    <FormControlLabel
                      className="text-left"
                      control={
                        <Checkbox
                          checked={disabledMessageChanged}
                          onChange={handleChangeDisabledMessage}
                          color="primary"
                        />
                      }
                      label="Player can disabled message"
                    />
                  </FormGroup>
                ) : (
                  ""
                )}

              </div>
            </form>
          </React.Fragment>
        )}

        <DialogActions>
          <Button
            color="inherit"
            startIcon={<CancelIcon />}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            startIcon={<SaveIcon />}
            variant="contained"
            color="primary"
            onClick={handleOk}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
